import React from 'react';
import { injectIntl } from 'react-intl';
import { NSchange, i18nIntl, isNotEmpty, parseClasses } from '../../lib/ep.js';

import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';

export const Checkbox = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const change = (e) => {
		if(props.change == undefined) return;
		props.change(props.name, e.target.checked);
	}

	let v = (props.value) ? props.value : (props.model != undefined ? NSchange(props.model, props.name) : '');

	if(v === "0" || v == "false") v = 0;
	if(v === "1" || v == "true") v = 1;

	const value = v;

	const disabled = props?.disabled ?? false;
	
	const has_error = (props.errors && props.errors[props.name]) ? props.errors[props.name] : false;
	const after_message = props?.after_message ?? false;

	const switcher = props?.switcher ?? false;

	let classname = props?.classname ?? 'input checkbox';
	classname = parseClasses(classname, props._class, 'checkbox');
	if(switcher) classname += ' is_switcher';
	
	let field_class = [];
	if(disabled) field_class.push('disabledField');

	let input_classes = [classname, ...field_class];
	if(has_error) input_classes.push('has_error');
	if(value) input_classes.push('is_checked');
	if(switcher) input_classes.push('ep-on');

	const is_fake = props?.is_fake ?? false;
	const after_component = isNotEmpty(props,'after_component') ? props.after_component : false;

	return (
		<div
			class={'react_field type_checkbox' + ((props._field_class != undefined) ? ' ' + props._field_class : '')}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			onFocus={props.onFocus}
			onBlur={props.onBlur}
			onClick={(!disabled) ? props.onClick : null}
			style={props._field_style}
		>
			<div class={input_classes.join(" ")} style={props?._style ?? null} title={props?._title ?? null}>
				<input
					name={props.name}
					id={props?.id ?? props.name}
					class={field_class.join(" ")}
					onChange={(e) => change(e)}
					type="checkbox"
					style={props.style}
					checked={value}
					disabled={(disabled) ? 'disabled' : null}
					tabIndex={(is_fake) ? -1 : null}
				/>

				<FieldLabel
					{...props.label_props}
					name={props.name}
					autotranslate={((props.children != undefined)) ? props.autotranslate : false}
				>{(props.children != undefined) ? props.children : "&nbsp;"}</FieldLabel>

				{(after_message !== false) && (
					<div class="gui_after_message">{i18n(after_message)}</div>
				)}

				{(after_component) && (
					<span class="after_component">{after_component}</span>
				)}

				{(has_error) && (
					<FieldErrorMessage>{has_error}</FieldErrorMessage>
				)}
			</div>
		</div>
	);
}

const Switcher = (props) => {
	return (
		<Checkbox
			switcher={true}
			{...props}
		/>
	)
}

export default injectIntl(Switcher);